import { combineReducers } from 'redux';
import { pageReducer } from './pageReducer';
import { userReducer } from './userReducer';

export default combineReducers({
    data: pageReducer,
    user: userReducer
});